export default from './FixedNavBar';


/** WEBPACK FOOTER **
 ** ./app/components/FixedNavBar/index.js
 **/